import { render, staticRenderFns } from "./AppVersionForm.vue?vue&type=template&id=77f56796&scoped=true"
import script from "./AppVersionForm.vue?vue&type=script&lang=js"
export * from "./AppVersionForm.vue?vue&type=script&lang=js"
import style0 from "./AppVersionForm.vue?vue&type=style&index=0&id=77f56796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f56796",
  null
  
)

export default component.exports